import { getHourDifference, isoDateToDateString } from "@/Helpers/times-ago";

export const getTimeLabelForCollab = (item) => {
  if (item?.brandApproval === "accepted") {
    const isBeforeLiveDate =
      new Date() <
      new Date(item?.liveAt || item?.campaignInfo?.campaignStartDate);
    return isBeforeLiveDate ? "Go Live at" : "Live Deadline";
  } else if (item?.response?.toUpperCase() === "ACCEPTED") {
    return "Draft Deadline";
  } else {
    return "Deadline";
  }
};

export const getRemainingTimeForCollab = (item) => {
  if (item?.brandApproval === "accepted") {
    if (item?.trackingLink?.length) {
      return "-";
    } else {
      const isBeforeLiveDate =
        new Date() <
        new Date(item?.liveAt || item?.campaignInfo?.campaignStartDate);
      return isBeforeLiveDate
        ? isoDateToDateString(
            item?.liveAt || item?.campaignInfo?.campaignStartDate
          )
        : getHourDifference(
            new Date(
              item?.liveAt || item?.campaignInfo?.campaignStartDate
            ).getTime() +
              48 * 60 * 60 * 1000
          );
    }
  } else if (!item?.isDraftExpired) {
    return getHourDifference(
      item?.response?.toUpperCase() === "ACCEPTED"
        ? item?.draftExpiry
        : item?.expireOn
    );
  } else {
    return "Expired";
  }
};
